import React from 'react'

const Homelifeandfamilyrelationship = () => {
  return (
    <div>
      <div>
        <h3>Ways with words</h3>
        <p className='question'>A. Fill in the blanks with an appropriate words.</p>
        <p>a. All my efforts to convince her for the tour were <u>futile</u>.</p>
        <p>b. The lost traveller <u>huddled up</u> under a shelter made of branches and leaves.</p>
        <p>c. Her rude behaviour was the main cause of <u>irritation</u> for him.</p>
        <p>d. She moved <u>awkwardly</u> in the room, thinking that I was watching.</p>
        <p>e. She is <u>mumbling</u> something, but I can't hear her.</p>
        <p>f. When I met my sister after a long time, she talked to me in a <u>feeble</u> voice.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Tick (√) the correct words that are similar in meaning to the underlined words.</p>
        <p>a. Rupa studied Science reluctantly due to her father's pressure.</p>
        <p>ii. unwillingly</p>
        <p>b. She moved her fingers exasperatedly through her hair.</p>
        <p>iv. annoyingly</p>
        <p>c. My grandmother is over eighty. She lifted her hands feebly.</p>
        <p>iii. weakly</p>
        <p>d. She is wearing a tattered shawl.</p>
        <p>ii. torn</p>
        <p>e. I have to work at two jobs to make ends meet in this expensive city.</p>
        <p>iv. earn just enough money</p>
      </div>
      <hr/>
      <div>
        <p className='question'>Consult an English dictionary and find the number of syllables in the following words.</p>
        <p>bury: bur-y → 2 syllables</p>
        <p>development: de-vel-op-ment → 4 syllables</p>
        <p>syllabic: syl-lab-ic → 3 syllables</p>
        <p>vowel: vow-el → 2 syllables</p>
        <p>education: ed-u-ca-tion → 4 syllables</p>
        <p>discipline: dis-ci-pline → 3 syllables</p>
        <p>examination: ex-am-i-na-tion → 5 syllables</p>
        <p>children: chil-dren → 2 syllables</p>
        <p>separately: sep-a-rate-ly → 4 syllables</p>
        <p>pronunciation: pro-nun-ci-a-tion → 5 syllables</p>
      </div>
      <hr/>
      <div>
        <h3>Comprehension</h3>
        <p className='question'>Answer the following questions.</p>
        <p className='question'>a. Why didn't the mother recognise her son Gopi?</p>
        <p>= The mother didn't recognize her son Gopi because she was eighty years old and had lost her memory.</p>
        <p className='question'>b. Why is the sister living with her mother?</p>
        <p>= The sister is living with her mother because she is a widow and there is no one else to take care of their mother.</p>
        <p className='question'>c. What is the sister's attitude towards her brother?</p>
        <p>= The sister is disappointed and upset with her brother because he has not visited or supported their mother for a long time.</p>
        <p className='question'>d. Does the son love his mother very much? How do you know that?</p>
        <p>= Yes, the son loves his mother very much. He shows his love by bending down and bringing his face close to his mother's wrinkled cheeks.</p>
         <p className='question'>e. What does the mother actually need: a blanket or the warmth of her son's love?</p>
         <p>= The mother actually needs the warmth of her son's love. In the story, the blanket symbolizes the love, care, and emotional connection she longs for from her son.</p>
         <p className='question'>f. What does the phrase 'the tattered blanket' mean? Is it only the blanket that is tattered?</p>
         <p>= The phrase 'the tattered blanket' symbolizes the mother's hurt emotions and neglected condition. It is not just the blanket that is tattered, but also the mother's feelings and the broken bond between her and her son.</p>
         <p className='question'>g. The son says, 'Amma can't remember who I am'. Do you think that he remembered his mother? Why didn't he answer when his sister asked, 'Do you remember your Amma?'</p>
         <p>= Yes, the son remembered his mother, but he didn't answer because he felt guilty. He had not written to her for a year and had not seen her for more than five years.</p>
      </div>
      <hr/>
      <div>
        <h3>Critical thinking</h3>
        <p className='question'>a. What can be the expectations of the parents from their offspring at the old age?</p>
        <p>= When parents grow old, they don't ask for expensive gifts or big surprises. What they really want is love, respect, and time from their children. After working hard all their lives to raise us, they hope that we won't forget them when they get old.
</p><p>
Old age can be lonely. Many parents feel left out because their children are busy with school, work, or friends. They don't want to feel like a burden. They just want someone to sit with them, talk to them, and listen to what they have to say.
</p><p>
Sometimes, they also want to feel useful. Maybe they want to help in small ways or share advice. Including them in family talks or asking for their opinion makes them feel happy and respected.
</p><p>
Every parent is different, but most of them want to feel loved, remembered, and cared for. A simple hug, a smile, or even asking “How are you today?” can mean a lot to them.
</p><p>
So, we should always try our best to be kind to our parents and give them the care they truly deserve.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>b. Some children who live in a distance tend to be indifferent to the feelings of their parents. Why do you think they are like that? Discuss.</p>
        <p>= These days, many children live far away from their parents because of studies, jobs, or business. They move to cities or even other countries to achieve their goals. At first, they may stay in touch, but slowly their busy life takes over. They get so involved in their work and personal life that they forget to call or visit their parents regularly.
</p><p>
As time passes, the bond between parents and children becomes weaker. Some children start thinking that success, money, and career are more important than spending time with their parents. This attitude hurts the parents, especially in their old age when they need love and support the most.
</p><p>
Also, after getting married and starting their own family, some children give more importance to their wife and kids. They may not mean to ignore their parents, but it happens because of their busy and distracted lives. As a result, the parents feel lonely, forgotten, and unhappy.
</p><p>
It's important to understand that parents don't need much just a little love, care, and attention. Even a small call or visit can make a big difference in their lives. We should not forget the sacrifices they made for us when we were young.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>c. A mother's love is everlasting and indispensable. Justify.</p>
        <p>= A mother's love is something that never fades. It starts even before we are born and stays with us for our whole life. From the time she carries us in her womb to when we grow up, her love never changes. It is full of care, kindness, and sacrifice.</p>
        <p>After birth, a child sees the mother as their first friend and protector. She feeds us, comforts us, teaches us, and always makes sure we are safe and happy. Mothers never ask for anything in return. They are always thinking about what is best for us, even when we don't notice it.</p>
        <p>A mother plays many roles in a child's life. She is a teacher when she helps with homework, a nurse when we are sick, and a friend when we need someone to talk to. She understands our needs without us even saying anything. She stays up all night if we are sick and celebrates every little achievement with joy.</p>
        <p>Many times, we forget to appreciate our mothers. We take their love for granted. But the truth is, without a mother's love, life feels empty. She is a gift from God that we should love and respect every day.</p>
        <p>In the end, no matter how old we get, we always need our mother. Her love is the strongest and purest form of love, and it truly is everlasting and indispensable.</p>
      </div>
      <hr/>
      <div>
        <h3>Grammar</h3>
        <p className='question'>B. Complete the following sentences with however, although or in spite of.</p>
        <p>a. <u>In spite of</u> the fact that he is an octogenarian, he still leads an active life.</p>
        <p>b. I still enjoyed the week, <u>although</u> the weather was bad.</p>
        <p>c. He has passed M.A. <u>However</u>, he hasn't got a job.</p>
        <p>d. <u>Although</u> I had a headache, I enjoyed the movie.</p>
        <p>e. Ramila didn't get the job, <u>in spite of</u> the fact that she had all the necessary qualifications.</p>
        <p>f. <u>In spite of</u> the fact that he had no money, he bought the car anyway.</p>
        <p>g. We can go to the park for lunch, <u>although </u>the weather report says it's going to rain.</p>
        <p>h. <u>Although</u> I speak English well, my first language is actually Maithili.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>C. Combine the following sentences using the words given in brackets.</p>
        <p>a. He was annoyed. He didn't say anything. (although)</p>
        <p>= Although he was annoyed, he didn't say anything.</p>
        <br/>
        <p>b. Playing the stock market is exciting. It can be risky. (however)</p>
        <p>= Playing the stock market is exciting, however, it can be risky.</p>
        <br/>
        <p>c. He works slowly. He never makes a mistake. (even though)</p>
        <p>= Even though he works slowly, he never makes a mistake.</p>
        <br/>
        <p>d. It was raining. We still went to the park. (in spite of)</p>
        <p>= In spite of the rain, we still went to the park</p>
        <br/>
        <p>e. Hark bought the watch. It was expensive. (despite)</p>
        <p>= Despite being expensive, Hark bought the watch.</p>
        <br/>
        <p>f. He is very poor. He wears expensive clothes. (but)</p>
        <p>= He is very poor but wears expensive clothes.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>D. Rewrite the following sentences using (a) although and (b) in spite of.</p>
        <p>a. He had very little time, but he offered to help us.</p>
        <p>= Although he had very little time, he offered to help us.</p>
        <p>= In spite of having very little time, he offered to help us.</p>
        <br/>
        <p>b. She is very poor, but she still wears expensive clothes.</p>
        <p>= Although she is very poor, she still wears expensive clothes.</p>
        <p>= In spite of being very poor, she still wears expensive clothes.</p>
        <br></br>
        <p>c. He's a millionaire, but he lives in a very small flat.</p>
        <p>= Although he's a millionaire, he lives in a very small flat.</p>
        <p>= In spite of being a millionaire, he lives in a very small flat.</p>
        <br/>
        <p>d. They have a lot of money, but they are still not happy.</p>
        <p>= Although they have a lot of money, they are still not happy.</p>
        <p>= In spite of having a lot of money, they are still not happy.</p>
        <br/>
        <p>e. The traffic was heavy, but we got there in time.</p>
        <p>= Although the traffic was heavy, we got there in time.</p>
        <p>= In spite of the heavy traffic, we got there in time.</p>
      </div>
    </div>
  )
}

export default Homelifeandfamilyrelationship
